module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "custom-page",
      "stacked": true
    }
  }, [_c('bc-navbar'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pages_maincontent"
    }
  }, [_c('div', {
    staticClass: "custom-page"
  }, [_c('div', {
    staticClass: "custom-page-title"
  }, [_vm._v("\n            " + _vm._s(_vm.customPage.title) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "custom-page-content",
    domProps: {
      "innerHTML": _vm._s(_vm.customPage.body)
    }
  })])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4aa22ee8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4aa22ee8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/custom-page.vue
// module id = 825
// module chunks = 0